// import  axios  from 'axios';
import { Axios } from '../plugins/axios.js'

const state = {
}

const getters = {

}

const mutations = {

}

const actions = {
  getSans ({ commit, state }, payload) {
    const data = payload.data
    let url = ''

    for (const content in data) {
      url += `&${content}=${data[content]}`
    }

    return new Axios()
      .get(`biav/v1/admin/sans/hours?${url}`)
      .then(response => {
        return response
      })
      .catch(() => {
        return 'error'
      })
  },

  removeSans ({ commit, state }, payload) {
    const data = payload.data
    return new Axios()
      .post('biav/v1/admin/sans/hours/delete', data)
      .then(response => {
        return response
      })
      .catch(() => {
        return 'error'
      })
  },

  editSans ({ commit, state }, payload) {
    const data = payload.data
    return new Axios()
      .post('biav/v1/admin/sans/hours/update', data)
      .then(response => {
        return response
      })
      .catch(() => {
        return 'error'
      })
  },
  createSans ({ commit }, payload) {
    return new Axios()
      .post('biav/v1/admin/sans/store_all_days_of_week', payload)
      .then(response => {
        return response
      })
      .catch(() => {
        return 'error'
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
